import { Auth } from 'aws-amplify';

const FORCE_LOGIN_KEY = 'tb_force_login';

let redirectInProgress = false;

export const getForceLoginFlag = () => {
  try {
    return sessionStorage.getItem(FORCE_LOGIN_KEY) === '1';
  } catch {
    return false;
  }
};

export const clearForceLoginFlag = () => {
  try {
    sessionStorage.removeItem(FORCE_LOGIN_KEY);
  } catch {
    // ignore
  }
};

const clearAmplifyStorage = () => {
  try {
    const keys = Object.keys(localStorage);
    keys.forEach((key) => {
      if (
        key.includes('CognitoIdentityServiceProvider') ||
        key.includes('amplify') ||
        key.startsWith('aws-amplify')
      ) {
        localStorage.removeItem(key);
      }
    });
  } catch {
    // ignore
  }
};

/**
 * Clears local Cognito/Amplify session and routes to /login.
 * Must clear storage BEFORE navigation — otherwise GuestGuard + currentUser
 * can restore isLoggedIn from cached Amplify tokens and bounce the user back in.
 */
export const forceLoginRedirect = () => {
  if (typeof window === 'undefined') return;
  if (redirectInProgress) return;

  const path = window.location.pathname || '';
  // Never hijack invite / password-setup flows
  if (
    path.includes('/change-password') ||
    path.includes('/password-activation') ||
    path.includes('/welcome-email')
  ) {
    return;
  }

  if (path.startsWith('/login') && getForceLoginFlag()) return;

  redirectInProgress = true;

  try {
    sessionStorage.setItem(FORCE_LOGIN_KEY, '1');
  } catch {
    // ignore
  }

  clearAmplifyStorage();

  Auth.signOut().catch(() => {
    // Cognito user may already be deleted after email change
  });

  window.location.href = '/login';
};

export const isAuthSessionError = (message, extensions) => {
  const code = extensions?.code;
  const msg = (message || '').toLowerCase();

  return (
    code === 'AUTH_NOT_AUTHENTICATED' ||
    code === 'AUTH_NOT_AUTHORIZED' ||
    msg.includes('unauthorized') ||
    msg.includes('session expired') ||
    msg.includes('not authenticated') ||
    msg.includes('not authorized') ||
    msg.includes('customer login not found')
  );
};
